import { render, staticRenderFns } from "./aspect-ratio.vue?vue&type=template&id=770251fa&"
import script from "./aspect-ratio.vue?vue&type=script&lang=js&"
export * from "./aspect-ratio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports